<template>
  <b-row class="footer-gnb">
    <b-col
      v-for="(lv1_info, lv1_idx) in sb_toc"
      :key="'dropdown_lv1' + lv1_idx"
      cols="12"
      sm="6"
      md="4"
      xl="3"
      class="gnb-item"
    >
      <h3>
        {{
          lang === 'ENG' && lv1_info.name_ea
            ? lv1_info.name_ea
            : lang === 'ENG' && lv1_info.name_em
            ? lv1_info.name_em
            : lv1_info.name
        }}
      </h3>
      <ul>
        <li v-for="(lv2_info, lv2_idx) in lv1_info.children" :key="'dropdown_lv2' + lv2_idx">
          <template
            v-if="lv2_info.appendix_type === null || report_types.includes(lv2_info.appendix_type)"
          >
            <div class="gnb-subitem cursor" @click="update_lv2_info(lv1_info, lv2_info)">
              {{
                lang === 'ENG' && lv2_info.name_ea
                  ? lv2_info.name_ea
                  : lang === 'ENG' && lv2_info.name_em
                  ? lv2_info.name_em
                  : lv2_info.name
              }}
            </div>
          </template>
        </li>
      </ul>
    </b-col>
  </b-row>
</template>

<script>
import { mapState, mapMutations, mapGetters, mapActions } from 'vuex';
import { updateParamsFromQueryString } from '@/components/util.js';

export default {
  name: 'FooterGnb',
  components: {},
  computed: {
    ...mapState('report_list', ['lang', 'view_mode']),
    ...mapGetters('story_board', [
      'selected_lv1',
      'selected_lv2',
      'sb_toc',
      'selected_viewer_disclosures'
    ]),
    ...mapGetters('report_list', ['selected_report', 'current_report_code']),
    ...mapGetters(['is_viewer']),
    report_types() {
      const user_selected_report_type = Object.keys(this.selected_report.report_type).map(
        item => item.split('v')[0]
      );

      if (this.selected_report?.data_center) {
        user_selected_report_type.push('DATACENTER');
      }
      return user_selected_report_type;
    }
  },
  methods: {
    ...mapMutations('story_board', ['update_selected_lv1', 'update_selected_lv2']),
    ...mapActions('story_board', ['fetch_viewer_sb_disclosures']),
    update_lv1_info(lv1_info) {
      window.scrollTo(0, 0);
      this.update_selected_lv1({
        lv1_info: lv1_info,
        view_mode: this.is_viewer ? 'viewer' : 'editor'
      });
      this.update_selected_lv2({
        lv2_info: lv1_info.children[0],
        view_mode: this.is_viewer ? 'viewer' : 'editor'
      });

      updateParamsFromQueryString('lv1', lv1_info.name, true);
      updateParamsFromQueryString('lv2', lv1_info.children[0].name, true);

      if (!this.selected_viewer_disclosures) {
        this.fetch_viewer_sb_disclosures({
          report_code: this.current_report_code,
          selected_lv_info: {
            lv1_info: lv1_info,
            lv2_info: lv1_info.children[0]
          }
        });
      }
    },
    update_lv2_info(lv1_info, lv2_info) {
      window.scrollTo(0, 0);
      this.update_selected_lv1({
        lv1_info: lv1_info,
        view_mode: this.is_viewer ? 'viewer' : 'editor'
      });
      this.update_selected_lv2({
        lv2_info: lv2_info,
        view_mode: this.is_viewer ? 'viewer' : 'editor'
      });

      updateParamsFromQueryString('lv1', lv1_info.name, true);
      updateParamsFromQueryString('lv2', lv2_info.name, true);

      if (!this.selected_viewer_disclosures) {
        this.fetch_viewer_sb_disclosures({
          report_code: this.current_report_code,
          selected_lv_info: {
            lv1_info: lv1_info,
            lv2_info: lv2_info
          }
        });
      }

      this.showDropdown = false;
    }
  }
};
</script>

<style scoped>
.gnb-item {
  color: #111111;
  margin-bottom: 24px;
}

.gnb-subitem {
  color: #666666;
}

.gnb-item h3 {
  font-size: clamp(16px, 1.5vw, 18px);
  margin-bottom: clamp(16px, 2vw, 24px);
  font-weight: 600;
  color: #000;
}

.gnb-item ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.gnb-item li {
  margin-bottom: clamp(12px, 1.5vw, 16px);
}

.gnb-item .gnb-subitem {
  font-size: clamp(14px, 1.2vw, 16px);
  color: #727272;
  text-decoration: none;
  font-weight: 500;
}

.gnb-item .gnb-subitem:hover {
  text-decoration: none;
}
</style>
